import { Tag, Switch, Icon, Button, Tooltip } from "antd";
import moment from "moment";
import React from "react";

function _renderActor(obj) {
  if (obj.date.Valid) {
    return (
      <Tag>
        {obj.actor_name.length <= "1" ? "Admin System" : obj.actor_name}
        {" | "}
        {moment(obj.date.Time).format("DD/MM/YYYY")}
      </Tag>
    );
  }
  return "-";
}

function sliceText(children, suffixCount) {
  const sliced = children.slice(0, suffixCount).trim() + "...";
  return sliced;
}

export default (toggleStatus, onEdit) => [
  {
    title: "เบอร์",
    dataIndex: "msisdn",
  },
  {
    title: "สถานะ",
    dataIndex: "status",
    render: (text, record) => {
      const convStatus = {
        enabled: true,
        disabled: false,
      };

      return (
        <Switch
          checkedChildren={<Icon type="check" />}
          unCheckedChildren={<Icon type="close" />}
          checked={convStatus[text]}
          onChange={(e) => toggleStatus(e, record)}
        />
      );
    },
  },
  {
    title: "สาเหตุ",
    dataIndex: "remark",
    width: "20%",
    render: (text) => {
      const textLimit = 42;
      if (!text) {
        return "-";
      }

      if (text.length > textLimit) {
        const suffixText = sliceText(text, textLimit);
        return (
          <Tooltip placement="topLeft" title={text}>
            <span style={{ cursor: "pointer" }}>{suffixText}</span>
          </Tooltip>
        );
      }

      return text;
    },
  },
  {
    title: "สร้างโดย",
    dataIndex: "created_by",
    render: (obj) => {
      return _renderActor(obj);
    },
  },
  {
    title: "อัพเดทโดย",
    dataIndex: "updated_by",
    render: (obj) => {
      return _renderActor(obj);
    },
  },
  {
    title: "การจัดการ",
    render: (record) => {
      return (
        <div>
          <Button style={{ margin: "2px" }} onClick={() => onEdit(record)}>
            แก้ไข
          </Button>
          <Button
            style={{ margin: "2px" }}
            onClick={() => toggleStatus("delete", record)}
          >
            ลบ
          </Button>
        </div>
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/containers/BlackList/column.js